import Api from '@/services/Index';

const getAll = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/transfer-out-request', data);
}

const getStudentForm = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/transfer-out-request/student-form', data);
}

const save = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/esl/transfer-out-request/store',formData,{
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/transfer-out-request/'+id);
}

const search = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/transfer-out-request',config);
}
const updateStep = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/approval/step/update/status/'+id,formData);
}
const saveAdminReview = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/esl/transfer-out-request/save-admin-reviews/'+id,data);
}
const saveDsoRelease = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    return Api.post('/esl/transfer-out-request/save-dso-releases/'+id,data);
}
const downloadFile = async (uuid) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/transfer-out-requests/download/' + uuid, {responseType: 'arraybuffer'});
}

export default {
    getAll,
    save,
    show,
    search,
    updateStep,
    getStudentForm,
    saveAdminReview,
    saveDsoRelease,
    downloadFile
}
